export default __webpack_public_path__ + "static/media/onboarding_navigation.dab1181d.gif";